import parse from "html-react-parser";
import * as DOMPurify from "dompurify";

const Html = ({body}: {body: string}) => {
    return (<>
        {parse(DOMPurify.sanitize(body, {USE_PROFILES: {html: true}}))}
    </>)
}
export default Html;